var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "inquiryDetail"
  }, [_c("a-row", {
    attrs: {
      type: "flex"
    }
  }, [_c("a-col", {
    attrs: {
      flex: 1
    }
  }, [_c("h3", [_vm._v(_vm._s(_vm.$t("inquiryDetail.baseInfo")))])])], 1), _c("a-row", [_c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("inquiryList.askPriceNo")) + "：")]), _vm._v(_vm._s(_vm.BasicInfo.orderNo))]), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("inquiryList.createTime")) + "：")]), _vm._v(_vm._s(_vm.BasicInfo.orderDate))]), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("inquiryList.erpCustomerName")) + "：")]), _c("router-link", {
    staticClass: "underline",
    attrs: {
      target: "_blank",
      to: {
        path: "/customermanager/editcustomer2",
        query: {
          erpCustomerId: _vm.BasicInfo.erpCustomerId
        }
      }
    }
  }, [_c("div", {
    staticStyle: {
      display: "inline-block"
    }
  }, [_vm._v(" " + _vm._s(_vm.BasicInfo.erpCustomerCode + " " + _vm.BasicInfo.erpCustomerName) + " ")])])], 1), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("inquiryList.sellerName")) + "：")]), _vm._v(_vm._s(_vm.BasicInfo.sellerName))]), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("orderDetailInfo.payTitle")) + "：")]), _vm._v(_vm._s(_vm.BasicInfo.payWay))]), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("orderDetailInfo.deliveryWay")) + "：")]), _vm._v(_vm._s(_vm.BasicInfo.deliveryWay == 1 ? _vm.$t("orderList.deliveryMethod3") : _vm.BasicInfo.deliveryWay == 2 ? _vm.$t("orderList.deliveryMethod2") : _vm.$t("orderList.deliveryMethod1")))]), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("inquiryList.linkErpRequest")) + "：")]), _vm.BasicInfo.orderIdNo ? _vm._l(_vm.BasicInfo.orderIdNo, function (item, index) {
    return _c("router-link", {
      attrs: {
        target: "_blank",
        to: {
          path: "/quoteDetail",
          query: {
            id: item.id
          }
        }
      }
    }, [_vm._v(" " + _vm._s(index > 0 ? "、" + item.no : item.no) + " ")]);
  }) : _vm._e()], 2), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("inquiryList.comment")) + "：")]), _vm._v(_vm._s(_vm.BasicInfo.customerNote))])], 1), _c("a-divider"), _c("a-row", {
    attrs: {
      type: "flex"
    }
  }, [_c("a-col", {
    attrs: {
      flex: 1
    }
  }, [_c("h3", [_vm._v(_vm._s(_vm.$t("orderDetailInfo.addressInfo")))])]), _c("a-col")], 1), _c("a-row", [_c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("orderDetailInfo.name")) + "：")]), _vm._v(_vm._s(_vm.BasicInfo.userName))]), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("orderDetailInfo.phone")) + "：")]), _vm._v(_vm._s(_vm.BasicInfo.userPhone))]), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("orderDetailInfo.postCode")) + "：")]), _vm._v(_vm._s(_vm.BasicInfo.addressPost))]), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("orderDetailInfo.detailedAddress")) + " "), _c("a-tooltip", {
    attrs: {
      placement: "topLeft"
    }
  }, [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t("orderDetailInfo.detailedAddressTips")) + " ")]), _c("a-icon", {
    attrs: {
      type: "info-circle"
    }
  })], 2), _vm._v(" ：")], 1), _vm._v(_vm._s(_vm.BasicInfo.provinceName + " " + _vm.BasicInfo.addressDetail))])], 1), _c("a-divider")], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };